module.exports = __webpack_public_path__ + "img/music.6c8d0bba.png";